import User from '@app/Interface/UserInterface';
import { Avatar, Dropdown, DropdownGroup, DropdownItem, DropdownSeparator, DropdownToggle, PageHeaderToolsItem } from '@patternfly/react-core';
import * as React from 'react';
import avatarImg from "@app/images/avatar.svg";
import { UserIcon } from '@patternfly/react-icons';
import { Link } from 'react-router-dom';
import UserAuthentication from '@app/Security/UserAuthentication';
import TemplateDefinitions from '@app/utils/TemplateDefinitions';
import { PageRouteContext } from '@app/Context/PageRouteContext';
import PageRouteHelper from "@app/Service/PageRouteHelper";

interface UserMenuProps {
    currentUser: User;
}

/**
 * user drop-down options placed in header tool.
 * see: https://www.patternfly.org/v4/components/dropdown/#dropdown-with-image-and-text 
 * @returns 
 */
const UserMenu: React.FC<UserMenuProps> = ({ currentUser }) => {

    const dropdownId = "user-menu-id";

    const { pageRouteState } = React.useContext(PageRouteContext);

    const myAccountPageRoute = PageRouteHelper.getPageRouteByTemplate(pageRouteState.pageRoutes, TemplateDefinitions.TEMPLATE_MY_ACCOUNT_PAGE);

    const changePasswordPageRoute = PageRouteHelper.getPageRouteByTemplate(pageRouteState.pageRoutes, TemplateDefinitions.TEMPLATE_CHANGE_PASSWORD_PAGE);

    const [isOpen, setIsOpen] = React.useState(false);

    const onToggle = (isOpen: boolean) => {

        setIsOpen(isOpen);

    };

    const onSelect = (event?: React.SyntheticEvent<HTMLDivElement> | undefined) => {

        setIsOpen(!isOpen);

        onFocus();

        if (event) {

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const target = event.currentTarget;

        }

    };

    const onFocus = () => {

        const element = document.getElementById(dropdownId);

        element?.focus;

    };

    const logoutHandler = () => {

        UserAuthentication.logout(true)
            .then((loggedOut: boolean) => {

                if (loggedOut) {
                    window.location.href = "/";
                } else {
                    console.log("something went wrong with the logout");
                }

            });

    }

    const dropdownItems = [
        <DropdownGroup key="group-1">
            <DropdownItem key="group-1-my-name" component="div" isPlainText>{currentUser.firstName + " " + currentUser.lastName}</DropdownItem>
            <DropdownSeparator key="dropdown separator" />
            <DropdownItem
                key="group-1-my-account"
                componentID="my-account"
                component={<Link to={myAccountPageRoute.id ? myAccountPageRoute.path : "#"}>My Account</Link>}
            ></DropdownItem>
            <DropdownItem
                key="group-2-change-password"
                componentID="change-password"
                component={<Link to={changePasswordPageRoute.id ? changePasswordPageRoute.path : "#"}>Change Password</Link>}
            ></DropdownItem>
            <DropdownItem key="group-1-log-out" componentID="log-out" onClick={logoutHandler}>Log Out</DropdownItem>
        </DropdownGroup>
    ];

    return (
        <PageHeaderToolsItem className="pf-u-mx-xs">
            <Dropdown
                onSelect={onSelect}
                isOpen={isOpen}
                dropdownItems={dropdownItems}
                isPlain
                alignments={{sm: 'left', md: 'right', lg: 'right'}}
                toggle={
                    <DropdownToggle
                        id={dropdownId}
                        onToggle={onToggle}
                        toggleIndicator={null}
                        icon={<UserIcon size="md" title={`User menu for ${currentUser.nickname}`} />}
                    ></DropdownToggle>
                }

            />
        </PageHeaderToolsItem>
    );

}

export default UserMenu;